var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.313,
    height: 21.313,
    viewBox: "0 0 21.313 21.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_arrow-down-thin-circle-outline",
    "data-name": "MDI / arrow-down-thin-circle-outline",
    transform: "translate(0 21.313) rotate(-90)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.313,
    height: 21.313,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20.313,
    height: 20.313,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_arrow-down-thin-circle-outline",
    "data-name": "Path / arrow-down-thin-circle-outline",
    d: "M8.525,15.371A6.846,6.846,0,1,0,1.679,8.525a6.873,6.873,0,0,0,6.846,6.846m0,1.679a8.525,8.525,0,1,1,8.525-8.525,8.507,8.507,0,0,1-8.525,8.525M7.673,9.838H5.115l3.41,3.376,3.41-3.376H9.378v-6H7.673",
    transform: "translate(2.131 2.131)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNav);
export default __webpack_public_path__ + "static/media/arrow-nav.b7268c8740712d268ec0e5bc1ec685e2.svg";
export { ForwardRef as ReactComponent };